<template>
  <aside class="containner">
    <v-card class="box">
      <div class="title" @click="goToUpdatePage()">
        <i class="fas fa-clock"></i>
        <!-- <i class="fas fa-history" style="color: #67C23A;"></i>  -->
        <span class="titleName">更新日志检测:<span>{{ monthplayer.noteTime }}</span></span>
      </div>
      <!-- <img src="https://www.ywsj.cf/themes/joe2.0/source/img/author_bg.jpg" alt=""> -->
      <div class="user">
 
        <!-- <div style="display:flex">
          <div class="username" style="cursor: pointer;" @click="goToUpdatePage()"> 游戏日志检测:</div>

          <div class="datestyle" style="cursor: pointer;">{{ monthplayer.noteTime }}</div>
        </div> -->
        <div class="count">
          <div class="item" @click="handleClike('/case')" >
            <span class="num"> <span class="num">{{ monthplayer.playerNow }}</span></span>
            <span class="itemName">当前在线人数</span>
          </div>
          <div class="item" @click="handleClike('/case')" >
            <span class="num">{{ monthplayer.playerMonth }}</span>
            <span class="itemName">月活跃人数</span>
          </div>

        </div>
        <div class="count">
          <div class="item" @click="goToCasePage()" >
            <span class="num">{{ $store.state.webSiteInfo.casedatediff }}天</span>
            <span class="itemName">武器箱</span>
          </div>
          <div class="item" @click="goToCasePage()" >
            <span class="num">{{ $store.state.webSiteInfo.datediff }}天</span>
            <span class="itemName">大行动</span>
          </div>

        </div>






        <div class="lianxi">

          <a class="qqgroup" @click="copyQQGroup" style="cursor: pointer;" title="复制QQ群号"
            rel="noopener noreferrer nofollow">
            <svg-icon icon-class="qqgroup" />
          </a>
          <a class="bilibili" href="https://space.bilibili.com/472852116" target="_blank" title="访问作者的b站主页"
            rel="noopener noreferrer nofollow">
            <svg-icon icon-class="Bzhan" />
          </a>



          <a class="qq" @click="copyQQ" style="cursor: pointer;" title="复制QQ号" rel="noopener noreferrer nofollow">
            <svg-icon icon-class="qq" />
          </a>
          <a class="wechat" @click="copyWechat" style="cursor: pointer;" title="复制微信号"
            rel="noopener noreferrer nofollow">
            <svg-icon icon-class="wechat" />
          </a>
          <a class="weibo" href="https://weibo.com/CS2CLUB" target="_blank" title="微博"
            rel="noopener noreferrer nofollow">
            <svg-icon icon-class="weibo" />
          </a>
          <!-- <a
            v-show="isShow(1)"
            class="email"
            :href="'mailto:' + $store.state.webSiteInfo.email"
            target="_blank"
            title="邮箱"
            rel="noopener noreferrer nofollow"
          >
            <svg-icon icon-class="email" />
          </a> -->

          <!-- <a class="zhihu" href="https://www.zhihu.com/people/he-he-85-83-34" target="_blank" title="知乎"
                        rel="noopener noreferrer nofollow">
                        <svg-icon icon-class="zhihu" />
                    </a> -->
        </div>
        <!-- 收藏本站 -->
        <div class="collect">
          <button class="btn" @click="handleCollect">收藏本网站</button>
        </div>
      </div>
    </v-card>
  </aside>
</template>
<script>
import { getMonthlyPlayerCount } from "@/api/index";
export default {
  data() {
    return {
      monthplayer: '',
    };
  },

  methods: {
    getMonthlyPlayer() {
      getMonthlyPlayerCount()
        .then((res) => {
          this.monthplayer = res.data;
          console.log(res.data, "555");
        })
        .catch((err) => {
          console.log(err);
        });
    },
    goToCasePage() {
      this.$router.push('/case')
    },
    goToUpdatePage() {
      this.$router.push('/updatenotes')
    },
    isShow(type) {
      return this.$store.state.webSiteInfo.showList.indexOf(type) != -1;
    },
    // handleClike(val) {
    //     window.location.href = val
    // },
    handleClike(val) {
      this.$router.push({
        path: val,
        hash: window.location.hash.substr(1),
      });
    },
    handleCollect() {
      console.log("666", this.$store.state.webSiteInfo);
      this.$toast({ type: "success", message: "按CTRL+D 键将本页加入书签" });
    },
    copyQQ() {
      const qqNumber = "1277198796"; // 直接硬编码QQ号
      navigator.clipboard.writeText(qqNumber).then(() => {
        this.$toast({ type: "success", message: "QQ号已复制到剪贴板" });
      }).catch(() => {
        this.$toast({ type: "error", message: "复制失败，请手动复制" });
      });
    },
    copyWechat() {
      const wechatNumber = "wangdayouzi13"; // 直接硬编码微信号
      navigator.clipboard.writeText(wechatNumber).then(() => {
        this.$toast({ type: "success", message: "微信号已复制到剪贴板" });
      }).catch(() => {
        this.$toast({ type: "error", message: "复制失败，请手动复制" });
      });
    },
    copyQQGroup() {
      const qqGroupNumber = "603807485"; // 直接硬编码QQ群号
      navigator.clipboard.writeText(qqGroupNumber).then(() => {
        this.$toast({ type: "success", message: "QQ群号已复制到剪贴板" });
      }).catch(() => {
        this.$toast({ type: "error", message: "复制失败，请手动复制" });
      });
    },
  },
  created() {
    this.getMonthlyPlayer();
    //   console.log("666",$store.state.webSiteInfo.authorInfo)
  },
};
</script>
<style lang="scss" scoped>
.containner {
  padding: 0;
  margin-top: 80px;

  @media screen and (max-width: 890px) {
    margin-top: 60px;
    margin-left: 7px;
    margin-right: 7px;

    .box {
      width: 100%;
      height: auto;
      background-color: var(--background-color);
      display: block;
      border-radius: 10px;
      position: relative;

      &:hover {
        box-shadow: 5px 4px 8px 6px rgba(7, 17, 27, 0.06);
        transition: all 0.3s;
      }

      &::before {
        content: "";
        position: absolute;
        top: 90px;
        left: 0;
        width: 100%;
        z-index: 2;
        background: linear-gradient(to bottom, rgba(255, 255, 255, 0), #fff);
      }

      img {
        width: 100%;
        height: 120px;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        object-fit: cover;
        position: absolute;
        top: 0;
      }

      .user {
        padding: 30px 15px 15px;
        display: flex;
        align-items: center;
        position: relative;
        flex-direction: column;

        .username {
          color: #f01515;
          display: block;
          font-size: 19px;
          font-weight: 550;
          margin-bottom: 6px;
        }

        .datestyle {
          color: #1474ff;
          display: block;
          font-size: 19px;
          font-weight: 550;
        }

        .count {
          width: 100%;
          padding-bottom: 10px;
          display: flex;
          align-items: center;
          -webkit-box-align: center;

          .item {
            position: relative;
            min-width: 0;
            -webkit-box-flex: 1;
            -ms-flex: 1;
            flex: 1;
            -webkit-box-orient: vertical;
            -webkit-box-direction: normal;
            -ms-flex-direction: column;
            flex-direction: column;
            font-size: 12px;
            display: flex;
            border-right: 1px solid var(--border-line);
            cursor: pointer;

            &:last-child {
              border-right: 0;
            }

            .num {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              font-weight: 500;
              font-size: 22px;
              margin-bottom: 3px;
              text-align: center;
              color: var(--site-color);
            }

            .itemName {
              font-size: 12px;
              text-align: center;
              color: var(--text-color);
            }
          }
        }

        .lianxi {
          border-top: 1px solid var(--border-line);
          justify-content: space-around;
          padding-top: 10px;
          text-align: center;
          align-items: center;
          font-size: 14px;
          display: flex;
          margin-top: 6px;

          a {
            display: inline-block;
            margin: 0 10px;
            transition: all 0.5s;

            &:hover {
              transform: scale(1.2);
            }

            svg {
              width: 25px;
              height: 25px;
            }
          }
        }

        .collect {
          margin-top: 8px;
          width: 100%;

          .btn {
            background-color: transparent;
            border-radius: 5px;
            border: 2px solid var(--theme-color);
            color: var(--theme-color);
            padding: 10px 20px;
            font-weight: 700;
            position: relative;
            transition: all 1s;
            z-index: 1;
            overflow: hidden;
            height: 30px;
            width: 100%;
            line-height: 8px;

            &:hover {
              color: white;

              &::before {
                width: 180%;
              }
            }

            &::before {
              content: "";
              height: 100%;
              position: absolute;
              left: -30px;
              top: 0;
              background-color: var(--theme-color);
              transform: skewX(45deg);
              width: 0%;
              transition: all 1s;
              z-index: -1;
            }
          }
        }
      }
    }
  }

  @media screen and (min-width: 891px) {
    .box {
      width: 300px;
      height: auto;
      background-color: var(--background-color);
      display: block;
      border-radius: 10px;
      position: relative;

      &:hover {
        box-shadow: 5px 4px 8px 6px rgba(7, 17, 27, 0.06);
        transition: all 0.3s;
      }

      .title {
        width: 100%;
        height: 45px;
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;
        background: var(--box-title_background);
        border-bottom: 1px solid var(--border-line);
        cursor: pointer;

        i {
          color: var(--theme-color);
          font-size: 16px;
          line-height: 45px;
          padding-left: 20px;
          font-weight: 700;
        }

        .titleName {
          color: var(--box-title_color);
          line-height: 45px;
          font-size: 16px;
          padding-left: 10px;
          font-weight: 600;

          span {
            color: var(--theme-color);
            font-weight: 700;
            margin-left: 5px;
          }
        }
      }

      &::before {
        content: "";
        position: absolute;
        top: 90px;
        left: 0;
        width: 100%;
        z-index: 2;
        background: linear-gradient(to bottom, rgba(255, 255, 255, 0), #fff);
      }

      img {
        width: 100%;
        height: 120px;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        object-fit: cover;
        position: absolute;
        top: 0;
      }

      .user {
        padding: 10px 15px 15px;
        display: flex;
        align-items: center;
        position: relative;
        flex-direction: column;

        .username {
          color: #f01515;
          display: block;
          font-size: 19px;
          font-weight: 550;
          margin-bottom: 6px;
        }

        .datestyle {
          color: #1474ff;
          display: block;
          font-size: 19px;
          font-weight: 550;
        }

        .count {
          width: 100%;
          padding-bottom: 10px;
          display: flex;
          align-items: center;
          -webkit-box-align: center;

          .item {
            position: relative;
            min-width: 0;
            -webkit-box-flex: 1;
            -ms-flex: 1;
            flex: 1;
            -webkit-box-orient: vertical;
            -webkit-box-direction: normal;
            -ms-flex-direction: column;
            flex-direction: column;
            font-size: 12px;
            display: flex;
            border-right: 1px solid var(--border-line);
            cursor: pointer;

            &:last-child {
              border-right: 0;
            }

            .num {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              font-weight: 500;
              font-size: 22px;
              margin-bottom: 3px;
              text-align: center;
              color: var(--site-color);
            }

            .itemName {
              font-size: 12px;
              text-align: center;
              color: var(--text-color);
            }
          }
        }

        .lianxi {
          border-top: 1px solid var(--border-line);
          justify-content: space-around;
          padding-top: 10px;
          text-align: center;
          align-items: center;
          font-size: 14px;
          display: flex;
          margin-top: 6px;

          a {
            display: inline-block;
            margin: 0 10px;
            transition: all 0.5s;

            &:hover {
              transform: scale(1.2);
            }

            svg {
              width: 25px;
              height: 25px;
            }
          }
        }

        .collect {
          margin-top: 8px;
          width: 100%;

          .btn {
            background-color: transparent;
            border-radius: 5px;
            border: 2px solid var(--theme-color);
            color: var(--theme-color);
            padding: 10px 20px;
            font-weight: 700;
            position: relative;
            transition: all 1s;
            z-index: 1;
            overflow: hidden;
            height: 30px;
            width: 100%;
            line-height: 8px;

            &:hover {
              color: white;

              &::before {
                width: 180%;
              }
            }

            &::before {
              content: "";
              height: 100%;
              position: absolute;
              left: -30px;
              top: 0;
              background-color: var(--theme-color);
              transform: skewX(45deg);
              width: 0%;
              transition: all 1s;
              z-index: -1;
            }
          }
        }
      }
    }
  }
}

@keyframes img {
  0% {
    -webkit-transform: rotate(0deg);
  }

  50% {
    -webkit-transform: rotate(180deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}
</style>